import { useEffect, useRef, useState } from "react";
import "../../lib/form/form.scss";
import "./Signup.scss";
import "../../components/errorStyle.scss";
import { MdCheckBoxOutlineBlank, MdCheckBox } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { set, useForm } from "react-hook-form";
import axios from "axios";
import Post from "../../utils/postUtil";
import CompanyNum from "../../components/CompanyNum";
import { style } from "@mui/system";
import ConfirmModal from "../../components/ConfirmModal";
import { getValue } from "@testing-library/user-event/dist/utils";
import Swal from "sweetalert2";

function Signup() {
  let navigate = useNavigate();

  // react hook form 라이브러리
  const {
    handleSubmit,
    register,
    watch,
    formState: { errors },
  } = useForm({ mode: "onChange" });
  const onError = (error) => {
    console.log(error);
  };
  const userPwd = useRef({});
  userPwd.current = watch("userPw", "");
  let userId = useRef({});
  userId = watch("userId", "");
  let userComNum = useRef({});
  userComNum = watch("userComNum", "");

  // 회원 정보
  const [checkPrivacy, setCheckPrivacy] = useState(false); //개인정보동의 체크 플래그
  const [postNum, setPostNum] = useState(""); //우편번호
  const [address, setAddress] = useState(""); //주소
  const [companyFile, setCompanyFile] = useState(""); // 사업자 등록증
  const [personallInfo, setPersonallInfo] = useState([]); // 개인정보동의

  // 모달
  const [showModal, setShowModal] = useState(false);
  const [idModal, setIdModal] = useState(false);
  const [idFalseModal, setIdFalseModal] = useState(false);
  const [comNumModal, setComNumModal] = useState(false);
  const [comNumFalseModal, setComNumFalseModal] = useState(false);
  const [personalOKModal, setPersonalOKModal] = useState(false);
  const [addressModal, setAddressModal] = useState(false);
  const [companyFileModal, setCompanyFileModal] = useState(false);

  // 개인정보 동의 체크
  let [check, setCheck] = useState(false);

  // 회원가입 개인정보 처리방침
  const getPersonalInfoData = async () => {
    try {
      const response = await axios.get("/api/contents", {
        params: {
          type: 4,
        },
      });

      setPersonallInfo(response.data.data[0]);
    } catch (error) {
      console.log(error);
    }
  };

  // 우편번호
  const [enroll_company, setEnroll_company] = useState({
    zonecode: "",
    address: "",
  });

  const onSubmit = (data) => {
    if (!address && !postNum) {
      setAddressModal(true);
    }

    if (
      data.userId === "" ||
      data.userPw === "" ||
      data.userPwConfirm === "" ||
      data.userComNum === "" ||
      data.userComName === "" ||
      data.userCeoName === "" ||
      data.userEmailForTax === "" ||
      data.userStaffName1 === "" ||
      data.staff1Position === "" ||
      data.userStaffMail1 === "" ||
      data.userStaffTelNum1 === ""
    ) {
      return;
    }

    if(companyFile === "") {
      setCompanyFileModal(true);
      return;
    }


    axios
      .post("/api/applicant", {
        id: data.userId,
        password: data.userPw,
        checkpassword: data.userPwConfirm,
        companyRegNum: data.userComNum,
        companyName: data.userComName,
        ceoName: data.userCeoName,
        faxNum: data.userFaxNum,
        emailForTax: data.userEmailForTax,
        postNum: enroll_company.zonecode,
        address1: enroll_company.address,
        address2: data.userDetailAddress,
        telNum: data.userCeoTelNum,
        staffName1: data.userStaffName1,
        staffPosition1: data.userStaffPosition1,
        staffEmail1: data.userStaffMail1,
        staffTelNum1: data.userStaffTelNum1.replace(/-/gi, ""),
        staffName2: data.userStaffName2,
        staffPosition2: data.userStaffPosition2,
        staffEmail2: data.userStaffMail2,
        staffTelNum2: data.userStaffTelNum2.replace(/-/gi, ""),
      })
      .then((response) => {
          const uploadFile = companyFile[0];
          const formData = new FormData();
          formData.append("files", uploadFile);
          formData.append("docs", JSON.stringify({ comment: "사업자등록증" }));

          axios({
            headers: {
              "Content-Type": "multipart/form-data",
            },
            method: "post",
            url: `/api/applicant/${userId}/doc`,
            data: formData,
          })
            .then((response) => {
              // console.log(response.data);
            })
            .catch((error) => {
              alert("파일 업로드 실패");
              console.log(error);
            });
        
        Swal.fire({
          icon: "success",
          title: "완료",
          text: "회원가입 신청이 완료되었습니다",
          confirmButtonColor: "dodgerBlue",
          iconColor: "dodgerBlue",
        });
        navigate("/");
      })
      .catch((error) => {
        if (error.response.status === 409) {
          Swal.fire({
            icon: "error",
            title: "실패",
            text: "중복체크 또는 입력란을 확인해 주세요.",
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "실패",
            text: "관리자에게 문의하십시오.",
          });
        }

        // alert("회원가입실패(관리자에게 문의하십시오)");
        console.log(error);
      });
  };

  // 사업자 등록증 업로드
  const onUploadSubmit = async (e) => {
    e.preventDefault();
    setCompanyFile(e.target.files);
  };

  const handleInput = (e) => {
    setEnroll_company({
      ...enroll_company,
      [e.target.name]: e.target.value,
    });
    setPostNum(enroll_company.zonecode);
    setAddress(enroll_company.address);
  };

  const handleComplete = () => {
    setShowModal(!showModal);
  };

  // 사업자번호 중복체크 모달
  const onCheckDupRegNum = async (e) => {
    const response = await axios.get("/api/applicant-dupl", {
      params: { companyRegNum: userComNum },
    });

    if (response.data === 0) {
      e.preventDefault();
      setComNumModal(true);
    } else {
      setComNumFalseModal(true);
      e.preventDefault();
    }
  };
  // 아이디 중복체크 모달
  const onCheckDupId = async (e) => {
    const response = await axios.get("/api/applicant-dupl", {
      params: { id: userId },
    });

    if (response.data === 0) {
      e.preventDefault();
      setIdModal(true);
    } else {
      setIdFalseModal(true);
      e.preventDefault();
    }
  };
  // 개인정보 수집 동의 모달
  const personalOK = async (e) => {
    if (!checkPrivacy) {
      setPersonalOKModal(true);
      e.preventDefault();
          }
  };

  const closeDoneModal = () => {
    setIdModal(false);
    setIdFalseModal(false);
    setComNumModal(false);
    setComNumFalseModal(false);
    setPersonalOKModal(false);
    setAddressModal(false);
    setCompanyFileModal(false);
  };

  useEffect(() => {
    getPersonalInfoData();
  }, []);

  return (
    <>
      {showModal ? (
        <div className="popup_bg_bbs" onClick={handleComplete}>
          <div className="popup_bbs">
            {/* <span className='close_btn' onClick={closeModal}><MdClose /></span> */}
            {
              <Post
                company={enroll_company}
                setcompany={setEnroll_company}
                showmodal={setShowModal}
                setPostNum={setPostNum}
                setAddress1={setAddress}
              ></Post>
            }
          </div>
        </div>
      ) : null}
      {idModal ? (
        <ConfirmModal
          closeModal={closeDoneModal}
          modalTitle={"사용 가능"}
          content={`${userId} 중복되지 않은 아이디입니다.`}
        />
      ) : null}
      {idFalseModal ? (
        <ConfirmModal
          closeModal={closeDoneModal}
          modalTitle={"사용 불가능"}
          content={`${userId} 중복된 아이디 입니다.`}
        />
      ) : null}
      {comNumModal ? (
        <ConfirmModal
          closeModal={closeDoneModal}
          modalTitle={"사용 가능"}
          content={`${userComNum} 중복되지 않은 사업자등록번호입니다.`}
        />
      ) : null}
      {comNumFalseModal ? (
        <ConfirmModal
          closeModal={closeDoneModal}
          modalTitle={"사용 불가능"}
          content={`${userComNum} 중복된 사업자등록번호 입니다.`}
        />
      ) : null}
      {personalOKModal ? (
        <ConfirmModal
          closeModal={closeDoneModal}
          modalTitle={"개인정보 약관 동의"}
          content={`개인정보 약관에 동의 하십시오.`}
        />
      ) : null}
      {addressModal ? (
        <ConfirmModal
          closeModal={closeDoneModal}
          modalTitle={"필수 입력"}
          content={`우편번호와 주소 입력은 필수입니다.`}
        />
      ) : null}
      {companyFileModal ? (
        <ConfirmModal
          closeModal={closeDoneModal}
          modalTitle={"필수 첨부"}
          content={`사업자 등록증 첨부는 필수입니다.`}
        />
      ) : null}
      <div className="contain joinus_contain">
        <h1 style={{ height: "2rem" }}></h1>
        <form
          className="form_contain"
          onSubmit={handleSubmit(onSubmit, personalOK)}
        >
          <div className="form_wrap ">
            <h2>개인정보 수집·이용·제공 동의서</h2>
            <div className="textarea_wrap consent">
              <div
                className="jodit-wysiwyg"
                dangerouslySetInnerHTML={{ __html: personallInfo.contents }}
              ></div>
            </div>

            <div className="input_wrap agree_btn ">
              <input
                type="checkbox"
                id="_check0"
                {...register("personalInfo", {
                  required: "* 개인정보 약관에 동의 하십시오.",
                })}
                onClick={(e) => {
                  e.target.checked
                    ? setCheckPrivacy(true)
                    : setCheckPrivacy(false);
                }}
              />
              <label
                htmlFor="_check0"
                className="checkbox_wrap"
                style={{ width: "10000%" }} /* onClick={()=>toggleMenu()} */
              >
                <div className="check_icon">
                  {/* {check ? <MdCheckBox /> : <MdCheckBoxOutlineBlank />} */}
                </div>
                내용을 모두 확인하였으며, 동의합니다.
              </label>
            </div>
            <div className="error_msg">
              {errors.personalInfo && <p>{errors.personalInfo?.message}</p>}
            </div>
          </div>
          <div className="form_wrap">
            <h2 className="alert_qoute">*표시는 필수값입니다.</h2>
            <div className="input_wrap">
              <input
                className="input_box"
                type="text"
                placeholder="아이디*"
                name="companyid"
                onChange={userId}
                {...register("userId", {
                  required: "* 아이디는 필수 입력입니다.",
                  pattern: {
                    // value: /^[A-Za-z+]{4,20}$/,
                    value: /^[a-z]+[a-z0-9]{5,19}$/g,
                    message:
                      "* 아이디는 영문,숫자 조합의 6자리 이상 20자리 이하입니다.",
                  },
                })}
              />
              {userId.length === 0 || errors.userId ? (
                <button
                  className="btn_none"
                  type="button"
                  onClick={onCheckDupId}
                  disabled
                >
                  중복체크
                </button>
              ) : (
                <button
                  className="btn_color"
                  type="button"
                  onClick={onCheckDupId}
                >
                  중복체크
                </button>
              )}
            </div>
            <div className="error_msg">
              {errors.userId && <p>{errors.userId?.message}</p>}
            </div>
            <div className="input_wrap">
              <input
                name="userPw"
                className="input_box"
                type="password"
                placeholder="비밀번호*"
                onChange={onError}
                {...register("userPw", {
                  required: "* 비밀번호는 필수 입력입니다.",
                  pattern: {
                    value:
                      /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$ %^&*-]).{8,16}$/,
                    message:
                      "* 비밀번호는 숫자와 영문대,소문자,특수문자 조합의 8자리 이상 16자리이하 구성입니다.",
                  },
                })}
              />
            </div>
            <div className="error_msg">
              {errors.userPw && <p>{errors.userPw?.message}</p>}
            </div>
            <div className="input_wrap">
              <input
                className="input_box"
                type="password"
                placeholder="비밀번호 확인*"
                onChange={onError}
                {...register("userPwConfirm", {
                  required: "* 비밀번호 확인은 필수 입력입니다.",
                  validate: (value) =>
                    value === userPwd.current ||
                    "* 비밀번호가 일치하지 않습니다.",
                })}
              />
            </div>
            <div className="error_msg">
              {errors.userPwConfirm && <p>{errors.userPwConfirm?.message}</p>}
            </div>
            <div className="input_wrap">
              <input
                className="input_box"
                type="text"
                placeholder="사업자등록번호* (-없이)"
                {...register("userComNum", {
                  required: "* 사업자등록번호는 필수 입력입니다.",
                  pattern: {
                    value: /^[0-9]{10}$/,
                    message:
                      "* 사업자등록번호는 10자리 숫자로 구성되어야 합니다.",
                  },
                })}
              />
              {userComNum.length === 0 || errors.userComNum ? (
                <button
                  className="btn_none"
                  type="button"
                  onClick={onCheckDupRegNum}
                  disabled
                >
                  중복체크
                </button>
              ) : (
                <button
                  className="btn_color"
                  type="button"
                  onClick={onCheckDupRegNum}
                >
                  중복체크
                </button>
              )}
            </div>
            <div className="error_msg">
              {errors.userComNum && <p>{errors.userComNum?.message}</p>}
            </div>
            <div className="input_wrap">
              <input
                className="input_box"
                type="text"
                placeholder="회사명*"
                {...register("userComName", {
                  required: "* 회사명은 필수 입력입니다.",
                })}
              />
            </div>
            <div className="error_msg">
              {errors.userComName && <p>{errors.userComName?.message}</p>}
            </div>
            <div className="input_wrap">
              <input
                className="input_box"
                type="text"
                placeholder="대표자명*"
                {...register("userCeoName", {
                  required: "* 대표자명은 필수 입력입니다.",
                })}
              />
            </div>
            <div className="error_msg">
              {errors.userCeoName && <p>{errors.userCeoName?.message}</p>}
            </div>
            <div className="input_wrap">
              <input
                style={{ backgroundColor: "#e8f0fe" }}
                className="input_box"
                type="text"
                placeholder="우편번호*"
                onChange={handleInput}
                onClick={(e) => {
                  e.preventDefault();
                  handleComplete();
                }}
                name="postNum"
                defaultValue={enroll_company.zonecode}
                {...register("userPostNum", {})}
                readOnly
              />
              <button
                className="btn_color"
                type="button"
                onClick={handleComplete}
                defaultValue={enroll_company.address}
              >
                주소검색
              </button>
            </div>
            <div className="error_msg">
              {errors.userPostNum && <p>{errors.userPostNum?.message}</p>}
            </div>
            <div className="input_wrap">
              <input
                style={{ backgroundColor: "#e8f0fe" }}
                className="input_box"
                type="text"
                placeholder="주소*"
                name="userAddress"
                defaultValue={enroll_company.address}
                onClick={(e) => {
                  e.preventDefault();
                  handleComplete();
                }}
                {...register("userAddress", {})}
                readOnly
              />
            </div>
            <div className="error_msg">
              {errors.userAddress && <p>{errors.userAddress?.message}</p>}
            </div>
            <div className="input_wrap">
              <input
                className="input_box"
                type="text"
                placeholder="상세주소"
                {...register("userDetailAddress", {})}
              />
            </div>
            <div className="input_wrap">
              <input
                className="input_box"
                type="text"
                placeholder="연락처"
                {...register("userCeoTelNum", {})}
              />
            </div>
            <div className="input_wrap">
              <input
                className="input_box"
                type="text"
                placeholder="팩스"
                name="userFaxNum"
                {...register("userFaxNum", {})}
              />
            </div>

            <div className="input_wrap">
              <input
                className="input_box"
                type="text"
                placeholder="전자계산서 수신자 이메일*"
                onChange={onError}
                {...register("userEmailForTax", {
                  required: "* 이메일은 필수 입력입니다.",
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                    message: "* 이메일 형식을 확인하세요.",
                  },
                })}
              />
            </div>
            <div className="error_msg">
              {errors.userEmailForTax && (
                <p>{errors.userEmailForTax?.message}</p>
              )}
            </div>
          </div>
          <div className="form_wrap">
            <h2>실무자 정보 입력</h2>
            <div className="input_wrap">
              <input
                className="input_box"
                type="text"
                placeholder="실무자 이름*"
                onChange={onError}
                {...register("userStaffName1", {
                  required: "* 실무자 이름은 필수 입력입니다.",
                })}
              />
            </div>
            <div className="error_msg">
              {errors.userStaffName1 && <p>{errors.userStaffName1?.message}</p>}
            </div>
            <div className="input_wrap">
              <input
                className="input_box"
                type="text"
                placeholder="직책*"
                {...register("userStaffPosition1", {
                  required: "* 직책은 필수 입력입니다.",
                })}
              />
            </div>
            <div className="input_wrap">
              <input
                className="input_box"
                type="text"
                placeholder="이메일*"
                onChange={onError}
                {...register("userStaffMail1", {
                  required: "* 실무자 이메일은 필수 입력입니다.",
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                    message: "이메일 형식을 확인하세요.",
                  },
                })}
              />
            </div>
            <div className="error_msg">
              {errors.userStaffMail1 && <p>{errors.userStaffMail1?.message}</p>}
            </div>
            <div className="input_wrap">
              <input
                className="input_box"
                type="text"
                placeholder="실무자 연락처* (숫자)"
                onChange={onError}
                {...register("userStaffTelNum1", {
                  required: "* 실무자 연락처는 필수 입력입니다.",
                  pattern: {
                    value:
                      // /^(01[016789]{1}|02|0[3-9]{1}[0-9]{1})[0-9]{3,4}[0-9]{4}$/,
                      /^01([0|1|6|7|8|9]?)-?([0-9]{3,4})-?([0-9]{4})$/,
                    message: "* 연락처 형식을 확인하세요.",
                  },
                })}
              />
            </div>
            <div className="error_msg">
              {errors.userStaffTelNum1 && (
                <p>{errors.userStaffTelNum1?.message}</p>
              )}
            </div>
            <div className="input_wrap">
              <input
                className="input_box"
                type="text"
                placeholder="실무자 이름"
                {...register("userStaffName2", {})}
              />
            </div>

            <div className="input_wrap">
              <input
                className="input_box"
                type="text"
                placeholder="직책"
                {...register("userStaffPosition2", {})}
              />
            </div>
            <div className="input_wrap">
              <input
                className="input_box"
                type="text"
                placeholder="이메일"
                {...register("userStaffMail2", {})}
              />
            </div>

            <div className="input_wrap">
              <input
                className="input_box"
                type="text"
                placeholder="실무자 연락처 (숫자)"
                {...register("userStaffTelNum2", {})}
              />
            </div>
            <CompanyNum files={companyFile} onChange={onUploadSubmit} />
            <div className="input_wrap btn_wrap">
              <button className="btn_color requir_btn">회원가입 요청</button>
            </div>
          </div>
        </form>
      </div>
    </>
  );
}
export default Signup;
